"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturesVerticalTabs;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _density = require("@site/pattern-library-utils/density");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _svgs = require("./svgs.js");
var _featuresVerticalTabItem = _interopRequireDefault(require("./features-vertical-tab-item.js"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _settings = require("@site/pattern-library-core/settings");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pl-c7x4595"
});
const ProgressWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ProgressWrapper",
  class: "pl-pl20gzo"
});
const ProgressFill = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ProgressFill",
  class: "pl-p15miz6z",
  vars: {
    "p15miz6z-1": [({
      open
    }) => open ? '0' : '-100%'],
    "p15miz6z-2": [({
      open,
      duration,
      active
    }) => open && active ? `transform ${duration}ms linear` : 'none'],
    "p15miz6z-3": [({
      active
    }) => active ? 'block' : 'none']
  }
});
const Tab = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Tab",
  class: "pl-t1cqqn1y",
  vars: {
    "t1cqqn1y-0": [({
      open
    }) => open ? `${_density.density['4']}` : `${_density.density['2']}`]
  }
});
const visibleTabAnimations = Array(5).fill(0).reduce((anims, _, index) => ({
  ...anims,
  [`&:nth-child(${index})`]: {
    'animation-delay': `calc(0.1s * ${index})`
  }
}), {});
const visibleTab = "pl-v1nqpgr6";
const TabToggle = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "TabToggle",
  class: "pl-t2vb03z"
});
const TabContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabContent",
  class: "pl-t75nsgi",
  vars: {
    "t75nsgi-0": [({
      open
    }) => open ? 'auto' : '0'],
    "t75nsgi-1": [({
      open
    }) => open ? '1' : '0']
  }
});
const TabsWrapper = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "TabsWrapper",
  class: "pl-tqt3dzg"
});
const Heading = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "Heading",
  class: "pl-hphm8ra",
  vars: {
    "hphm8ra-1": [({
      visible
    }) => visible ? '0' : '1.25rem'],
    "hphm8ra-2": [({
      visible
    }) => visible ? 1 : 0]
  }
});
const ItemContainer = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "ItemContainer",
  class: "pl-isbtda5",
  vars: {
    "isbtda5-0": [({
      open
    }) => open ? 1 : 0]
  }
});
const MediaWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MediaWrapper",
  class: "pl-m1pbwia6"
});
const LeftContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LeftContainer",
  class: "pl-lbm3qlm"
});
const VerticalTabContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VerticalTabContainer",
  class: "pl-v1tbb2v3"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-cmsr5i0"
});

/**
 * FeaturesVerticalTabs component.
 * @module FeaturesVerticalTabs
 *
 * @param {Object} props React props
 * @param {string} props.id The component's id (required for scroll-to-section functionality)
 * @param {string} props._name Section Tracking name
 * @param {string} props.heading Heading text
 * @param {Object} props.cta Call to Action button data
 * @param {array} props.items Array of child TabItems
 * @param {string} props.verticalMargin Vertical Spacing value
 * @param {boolean} props.useHowToMarkup Trigger HowTo Microdata Markup for items
 * @returns {React.ReactElement} FeaturesVerticalTabs component
 * @public
 */
function FeaturesVerticalTabs({
  id,
  _name,
  heading,
  cta,
  items,
  verticalMargin = 'none',
  verticalPadding = 'small',
  useHowToMarkup = false
}) {
  const tabDuration = 8000; // milliseconds
  const [userHasInteracted, setuserHasInteracted] = (0, _react.useState)(false);
  const [openIndex, setOpenIndex] = (0, _react.useState)(0);
  const [documentLoaded, setDocumentLoaded] = (0, _react.useState)(false);
  const handleToggleClick = index => {
    setOpenIndex(index);
    setuserHasInteracted(true);
    // Scroll to the top of the Feature Vertical Tabs section
    if (id) {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  const schemaAttributes = (0, _settings.getSchemaAttributes)();
  (0, _react.useEffect)(() => {
    if (userHasInteracted) return;
    const interval = setInterval(() => {
      setOpenIndex((openIndex + 1) % items.length);
    }, tabDuration);
    return () => clearInterval(interval);
  }, [openIndex, userHasInteracted]);
  (0, _react.useEffect)(() => {
    setDocumentLoaded(true);
  }, []);
  const renderToggleContent = ({
    title,
    id: tabId,
    description,
    desktop
  }, index) => {
    const open = documentLoaded && openIndex === index;
    return /*#__PURE__*/_react.default.createElement(Tab, (0, _extends2.default)({
      open: open,
      "data-cy": "vertical-tab"
    }, useHowToMarkup ? schemaAttributes.howToStep : null), /*#__PURE__*/_react.default.createElement(TabToggle, (0, _extends2.default)({
      id: `id-${tabId}-toggle`,
      "aria-expanded": open,
      "aria-controls": `id-${tabId}-content`,
      onClick: () => handleToggleClick(index),
      "data-cy": "tab-button"
    }, _patternLibraryUtils.tracking.create(`id-${tabId}-toggle`, true, true)), open ? _svgs.CloseSVG : _svgs.OpenSVG, /*#__PURE__*/_react.default.createElement("p", useHowToMarkup ? schemaAttributes.name : null, title), useHowToMarkup && /*#__PURE__*/_react.default.createElement("meta", {
      itemProp: "image",
      content: desktop.url
    })), /*#__PURE__*/_react.default.createElement(TabContent, {
      id: `id-${tabId}-content`,
      role: "region",
      "aria-labelledby": `id-${tabId}-toggle`,
      open: open
    }, /*#__PURE__*/_react.default.createElement(ProgressWrapper, null, /*#__PURE__*/_react.default.createElement(ProgressFill, {
      open: open,
      duration: tabDuration,
      active: !userHasInteracted
    })), /*#__PURE__*/_react.default.createElement(_text.default.p, (0, _extends2.default)({
      as: "paragraph",
      size: -1
    }, useHowToMarkup ? schemaAttributes.text : null), description)));
  };
  const renderImageContent = (item, index) => {
    const open = index === openIndex || !documentLoaded;
    return /*#__PURE__*/_react.default.createElement(ItemContainer, {
      open: open
    }, open && /*#__PURE__*/_react.default.createElement(_featuresVerticalTabItem.default, item));
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "features-vertical-tabs",
    padding: "none",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement("div", useHowToMarkup ? schemaAttributes.howTo : null, /*#__PURE__*/_react.default.createElement(VerticalTabContainer, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(LeftContainer, null, /*#__PURE__*/_react.default.createElement(Heading, {
    visible: documentLoaded ? 1 : 0,
    headlineSize: "h1",
    headlineTag: "h2",
    heading: heading,
    textAlign: "start",
    itemPropHeading: useHowToMarkup ? schemaAttributes.name.itemProp : null
  }), /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(TabsWrapper, {
    className: !documentLoaded && visibleTab
  }, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: i
  }, renderToggleContent(item, i)))), cta && /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  })))), /*#__PURE__*/_react.default.createElement(MediaWrapper, null, /*#__PURE__*/_react.default.createElement("ul", null, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: i
  }, renderImageContent(item, i))))))));
}
FeaturesVerticalTabs.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  heading: _propTypes.default.string,
  cta: _propTypes.default.object,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_featuresVerticalTabItem.default.propTypes)),
  useHowToMarkup: _propTypes.default.bool,
  ..._patternLibraryUtils.marginProps
};